/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_F_Cta_Label1Inputs */

const vi_sitesettings_f_cta_label1 = /** @type {(inputs: Sitesettings_F_Cta_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ trên nút`)
};

/**

* @param {Sitesettings_F_Cta_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_f_cta_label1 = /** @type {((inputs?: Sitesettings_F_Cta_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_F_Cta_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_f_cta_label1(inputs)
});
export { sitesettings_f_cta_label1 as "siteSettings_f_cta_label" }